const previewHeader = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginY: '2rem',
};

const errorMessage = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '20px',
};

const card = {
  marginTop: '20px',
  marginX: 'auto',
  width: '100%',
};

const styleBox = {
  display: {
    xs: 'block',
    sm: 'flex',
  },
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 'auto',
  width: '100%',
  padding: '10px',
};

const formInput = {
  width: {
    xs: '100%',
    sm: '70%',
    md: '75%',
    lg: '85%',
    xl: '90%',
  },
};

export default {
  previewHeader,
  styleBox,
  formInput,
  card,
  errorMessage,
};
